import React from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import withRouter from "components/Common/withRouter"
import { Tag } from "antd"

const DisturbanceListItem = props => {

  // Get tag based on status id
  const getTag = (id) => {
    switch (id) {
      case "3":
        return (
          <Tag color="" style={{ borderRadius: "100px" }} className="mb-2 pe-2">
            <i className="mdi mdi-check-bold me-1" style={{ color: "#49a02a" }} />
            {props.t(props.item.status)}
          </Tag>
        )
        case "2":
          return (
          <Tag color="orange" style={{ borderRadius: "100px" }} className="mb-2 pe-2">
            <i className="mdi mdi-alert me-1" />
            {props.t(props.item.status)}
          </Tag>
        )
        default:
          return (
          <Tag color="red" style={{ borderRadius: "100px" }} className="mb-2 pe-2">
            <i className="mdi mdi-alert me-1" />
            {props.t(props.item.status)}
          </Tag>
        )
    }
  }

return (
  <>
    <div className="d-flex">
      <div
        className="align-self-center overflow-hidden me-auto"
      >
        <div>
          <h5 className="font-size-14 text-truncate mb-1">
            <a
              href={"/disturbance-notice/" + props.item.guid}
              target="_blank"
              rel="noreferrer"
            >
              {props.t(props.item.title)}
            </a>
          </h5>
          <p className="text-muted mb-2">{props.item.date}</p>

          {getTag(""+props.item.current_status)}
          {props.item.targets.map(target => (
            <Tag key={"" + target} color="blue" style={{ borderRadius: "100px" }} className="mb-2 px-2">
              {props.t(target)}
            </Tag>
          ))}
        </div>
      </div>
    </div>
  </>
)
}

DisturbanceListItem.propTypes = {
  t: PropTypes.any,
  item: PropTypes.any,
}

export default withRouter(withTranslation()(DisturbanceListItem))
